import classnames from 'classnames';
import React from 'react';
import styles from "./Seperator.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const Separator = ({
  marginTop,
  marginBottom,
  className,
  variant = 'HORIZONTAL'
}) => {
  const hrStyle = {
    marginBottom: '1.5rem'
  };
  const mergeStyles = props => ({
    ...hrStyle,
    ...props
  });
  return /*#__PURE__*/_jsx("hr", {
    className: classnames(styles.separator, {
      [styles.vertical]: variant === 'VERTICAL'
    }, className),
    style: mergeStyles({
      marginTop,
      marginBottom
    })
  });
};